export function getUmbracoMediaUrl(url?: string) {
  const GRAPHQL_URL = process.env.GRAPHQL_URL?.replace("/graphql", "")
  let ORIGIN = process.env.ORIGIN?.replace(/\/$/, "")

  // If ORIGIN is localhost, use dev environment
  if (
    ORIGIN &&
    (ORIGIN.includes("localhost") || ORIGIN.includes("127.0.0.1"))
  ) {
    ORIGIN = "https://dev.egged.co.il"
  }

  const baseURL = ORIGIN || GRAPHQL_URL || ""
  if (!url) {
    return ""
  }

  // Step 1: Ensure all URLs are HTTPS
  let processedUrl = url
  if (url.startsWith("http://")) {
    processedUrl = url.replace(/^http:\/\//, "https://")
  }

  // Step 2: If URL contains /media/, replace the base URL
  if (processedUrl.includes("/media/")) {
    // Handle relative paths
    if (processedUrl.startsWith("/media/")) {
      return baseURL?.endsWith("/")
        ? `${baseURL}${processedUrl.substring(1)}`
        : `${baseURL}${processedUrl}`
    }

    // Handle absolute URLs with /media/
    if (processedUrl.startsWith("https://")) {
      try {
        const urlObj = new URL(processedUrl)
        const path = urlObj.pathname + urlObj.search + urlObj.hash
        return baseURL?.endsWith("/")
          ? `${baseURL}${path.substring(1)}`
          : `${baseURL}${path}`
      } catch {
        // If URL parsing fails, return the HTTPS version
        return processedUrl
      }
    }
  }

  return processedUrl
}
